import React from 'react';
import Script from 'next/script';

import { useConsentManager } from '../consent-manager';

declare global {
  interface Window {
    ChiliPiper?: {
      submit: (
        accountName: string,
        routerName: string,
        options: {
          trigger: string;
          lead: Record<string, string | undefined>;
          debug?: boolean;
          onSuccess?: (data?: unknown) => void;
          onError?: (data?: unknown) => void;
          onRouted?: (data?: unknown) => void;
          onDisqualified?: (data?: unknown) => void;
          onClose?: (data?: unknown) => void;
        },
      ) => void;
    };
  }
}

/**
 * Load the ChiliPiper scheduling script after airgap.js is initialized
 */
export const ChiliPiperScript: React.FC = () => {
  const { airgap } = useConsentManager();
  return (
    <>
      {airgap && (
        <Script
          id="chilipiper-concierge"
          src="https://transcend.chilipiper.com/concierge-js/cjs/concierge.js"
          crossOrigin="anonymous"
          strategy="afterInteractive"
        />
      )}
    </>
  );
};
